import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fluentui/react';

import { withAdsStudioStyles } from '../../../theme/with-ads-studio-styles';
import { getGridDecorativeIconStyle } from '../styles/tiles-grid-cell-decorative-icon';

const CellDecorativeIcon = ({
  iconName,
  classes,
  i18n,
}) => (
  <div className={classes.centerContainer}>
    <div className={classes.circleContainer}>
      <Icon className={classes.iconContent} iconName={iconName} />
      <span className={classes.labelName}>{i18n.getString(_TL_('Video'))}</span>
    </div>
  </div>
);

CellDecorativeIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    centerContainer: PropTypes.string,
    circleContainer: PropTypes.string,
    iconContent: PropTypes.string,
    labelName: PropTypes.string,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

CellDecorativeIcon.defaultProps = {
  classes: {},
};

export const TilesGridCellDecorativeIcon
  = withAdsStudioStyles(CellDecorativeIcon, getGridDecorativeIconStyle);
